// client/customer/src/utils/registration/postCustomerFromApp.ts
import api from '../../lib/api';

export type RegistrationPayload = {
  last_name: string;
  first_name: string;
  tel: string;
  password: string;
  gender?: string | null;
  birthday?: string | null;      // 'YYYY-MM-DD'
  age_band?: string | null;
  nationality?: string | null;
  province?: string | null;
  district?: string | null;
  channel?: string | null;
  telegram_id?: string | null;
  source?: string | null;
  store_id?: number | null;
  self_register_session_id?: number | null;
};

export type RegistrationResponse = {
  customer_id: number;
  name: string;
  auth_token: string;
};

export const postCustomerFromApp = async (
  payload: RegistrationPayload
): Promise<RegistrationResponse> => {
  const res = await api.post<RegistrationResponse>('/api/customer-app/registration', payload);
  return res.data;
};

export const claimSelfRegisterIntake = async (payload: {
  source: string;
  store_id: number;
  self_register_session_id?: number | null;
}): Promise<{ self_register_session_id: number; reservation_id: number }> => {
  const res = await api.post<{ self_register_session_id: number; reservation_id: number }>(
    '/api/customer-app/registration/claim-intake',
    payload
  );
  return res.data;
};
